// extracted by mini-css-extract-plugin
export default {"secret__wrapper":"Clients_secret__wrapper__ZnRiZ","secret__wrapperError":"Clients_secret__wrapperError__tsPPV"};